<template>
  <div>
    <div class="custclue-container" v-if="customer">
      <!-- 客户卡片信息 -->
      <card-info :info="customer" />
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" v-if="isPut">
        <van-grid-item>
          <!-- <div class="flex-center" v-hasPermi="['cust:order:edit']">
            <van-icon name="edit" size="22" color="#07c160" />
            <span style="font-size:14px;color:#646566" @click="handleUpdate(customer.custSaleId)">修改</span>
          </div> -->
        <div class="flex-center" v-hasPermi="['cont:putcontract:add']">
          <van-icon name="plus" size="22" color="#f76f6c" />
          <span style="font-size: 14px; color: #646566" @click="handleContractPut(customer.custSaleId)">添加合同</span>
        </div>
        </van-grid-item>
        <van-grid-item>
          <!-- <div class="flex-center">
          <van-icon name="exchange" size="22" color="#f76f6c" />
          <span style="font-size:14px;color:#646566" @click="handleApply(customer.custId)" v-hasPermi="['cust:order:apply']">申领</span>
        </div> -->
        </van-grid-item>

        <van-grid-item>
          <!-- <div class="flex-center">
          <van-icon name="delete-o" size="22" color="#5f79fe" />
          <span style="font-size:14px;color:#646566" @click="handleDelete(customer.custSaleId)" v-hasPermi="['cust:order:remove']">删除</span>
        </div> -->
        </van-grid-item>
        <van-grid-item />

      </van-grid>
      <!-- 跟进 联系人-->
      <cont-tab :listVisitData="listVisit" :id="visitForm.custId" :custContactOptionsData="custContactOptions" :custStatusData="form.custStatus" @handleaddvisit="addVisit" @delContact="handleDelContact" @handleaddContract="addContract" @handleEditContract="handleUpdateContact" />
      <!--添加回访记录-->
      <van-dialog v-model="visitShow" title="添加回访记录" :beforeClose="visitBeforeClose" :close-on-click-overlay="true">
        <van-form ref="addVisitForm" validate-trigger="onSubmit" class="dialog-form-wrap">
          <van-field readonly clickable v-model="visitForm.visitTypeName" @click="showPicker('visitType')" :rules="[{ required: true}]" label="联系类型" placeholder="请选择联系类型" required />
          <van-field readonly clickable v-model="visitForm.contactName" label="联系人" @click="showPicker('contactId')" :rules="[{ required: true}]" placeholder="请选择联系人" required />
          <van-field v-model="visitForm.content" rows="3" autosize label="内容" type="textarea" show-word-limit :rules="[{ required: true}]" placeholder="请填写访问内容" required />
        </van-form>
      </van-dialog>
      <!--修改公海客户-->
      <van-dialog v-model="show" title="修改订单客户" :beforeClose="beforeUpdateClose" close-on-click-overlay>
        <van-form ref="form" validate-trigger="onSubmit" style="height: 300px; overflow: scroll; margin: 10px 10px">
          <van-cell-group>
            <van-field v-model="form.custName" label="客户名称" :rules="[{ required: true }]" required placeholder="请填写客户名称" />
            <van-field readonly clickable v-model="form.custLevelName" @click="showPicker('custLevelId')" label="客户意向等级" :rules="[{ required: true}]" required placeholder="请选择客户意向等级" />
            <van-field readonly clickable v-model="form.areaName" label="地区" @click="showPicker('areaId')" :rules="[{ required: true}]" required placeholder="请选择地区" />
            <van-field readonly clickable v-model="form.industryName" label="行业" @click="showPicker('industryCode')" :rules="[{ required: true}]" required placeholder="请选择行业" />
            <van-field readonly clickable v-model="form.custTypeName" @click="showPicker('custType')" label="客户类型" :rules="[{ required: true }]" required placeholder="请选择客户类型" />
            <van-field readonly clickable v-model="form.custSourceName" @click="showPicker('custSource')" label="客户来源" :rules="[{ required: true}]" required placeholder="请选择客户来源" />
            <van-field readonly clickable v-model="form.businessTypeName" @click="showPicker('businessTypeId')" label="产品类型" :rules="[{ required: true }]" placeholder="请选择产品类型" required />
            <van-field v-model="form.scale" label="企业规模" placeholder="请填写企业注册资金" :rules="[{ required: true }]" required/>
            <van-field v-model="form.custAddress" label="详细地址" placeholder="请填写详细地址" :rules="[{ required: true }]" required/>
            <!-- <van-field v-model="form.clueId" label="线索ID" placeholder="请填写线索ID"  /> -->
            <van-field v-model="form.mainProducts" label="主营产品" placeholder="请填写企业主营产品" />
            <van-field v-model="form.remark" label="备注" />
          </van-cell-group>
        </van-form>
      </van-dialog>
      <!--添加联系人-->
      <van-dialog v-model="addContactShow" :title="contactTitle" :beforeClose="beforeClose" close-on-click-overlay>
        <van-form ref="addForm" validate-trigger="onSubmit" class="dialog-form-wrap">
          <van-field v-model="contactForm.contactName" label="姓名" :rules="[{ required: true }]" name="contactName" placeholder="请输入姓名" required />
          <van-field v-model="contactForm.mobile" label="手机" :rules="[
              { required: true,pattern: /^1[3456789]\d{9}$/, message: '手机号码格式错误！'}
            ]" type="tel" placeholder="请输入手机号码" required/>
          <van-field name="radio" label="性别" :rules="[{ required: true}]" required>
            <template #input>
              <van-radio-group v-model="contactForm.sex" direction="horizontal" icon-size="14px">
                <van-radio :name="item.dictValue" v-for="item in sexOptions" :key="item.dictValue">{{item.dictLabel}}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="contactForm.jobs" label="职务" :rules="[{ required: true}]" placeholder="请输入职务" required/>
          <van-field v-model="contactForm.weixinSn" label="微信号" placeholder="请输入微信号" />
          <van-field v-model="contactForm.qq" label="QQ号" type="number" placeholder="请输入QQ号" />
          <van-field v-model="contactForm.email" label="邮箱" placeholder="请输入邮箱地址" />
          <van-field v-model="contactForm.deptName" label="部门名称" placeholder="请输入部门名称" />
          <van-field v-model="contactForm.age" label="年龄" placeholder="请输入年龄" />
          <van-field v-model="contactForm.birthday" readonly clickable name="calendar" label="生日" placeholder="请点击选择日期" @click="showBirthdayCalendar = true" />
          <van-field v-model="contactForm.ideTypeName" readonly clickable name="picker" label="证件类型" placeholder="请点击选择证件类型" @click="showPicker('ideType')" />
          <van-field v-model="contactForm.ideSn" label="证件号" placeholder="请输入证件号" />
          <van-field v-model="contactForm.jobTitle" label="工作头衔" placeholder="请输入工作头衔" />
          <van-field v-model="contactForm.nickName" label="用户昵称" placeholder="请输入用户昵称" />
          <van-field v-model="contactForm.roleRelationName" readonly clickable name="picker" label="角色关系" placeholder="请点击选择角色关系" @click="showPicker('roleRelation')" />
          <van-field v-model="contactForm.intimacyName" readonly clickable name="picker" label="亲密度" placeholder="请点击选择亲密度" @click="showPicker('intimacy')" />
          <van-field type="textarea" v-model="contactForm.remark" label="备注" placeholder="请输入相关备注信息" />
        </van-form>
      </van-dialog>


    <!--添加合同信息-->
    <van-dialog v-model="contract" title="添加合同信息" width="95%" style="height:80%" class="editClue"  :beforeClose="addContractBeforeClose" close-on-click-overlay>
      <van-form ref="contractForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-cell-group>
          <van-field v-model="contractForm.contractName" label="合同标题" :rules="[{ required: true}]" required placeholder="请填写合同标题" />
          <van-field v-model="contractForm.contractNum" label="合同编号" :rules="[{ required: true }]" required placeholder="请填写合同编号" />
          <van-field v-model="contractForm.contractMoney" label="合同金额" :rules="[{ required: true }]" required placeholder="请填写合同金额" />
          <van-field readonly clickable v-model="contractForm.contractTypeName" @click="showPicker('contractType')" label="合同类型" required placeholder="请选择合同类型" />
          <van-field readonly clickable v-model="contractForm.contractStatusName" @click="showPicker('contractStatus')" label="合同状态" placeholder="请选择合同状态" />
          <van-field readonly clickable v-model="contractForm.payModeName" @click="showPicker('payMode')" label="支付方式" required placeholder="请选择支付方式" />
          <van-field v-model="contractForm.startTime" readonly clickable name="calendar" label="开始时间" placeholder="点击选择日期" @click="showStartCalendar = true;" required />
          <van-field v-model="contractForm.endTime" readonly clickable name="calendar" label="结束时间" placeholder="点击选择日期" @click="showEndCalendar = true" required />
          <van-field v-model="contractForm.signTime" readonly clickable name="calendar" label="签约日期" placeholder="点击选择日期" @click="showSignCalendar = true" required />
          <van-field v-model="contractForm.custSignedUser" label="对方签约人" :rules="[{ required: true}]" required placeholder="请填写对方签约人" />
          <van-field v-model="contractForm.signedUserMobile" label="对方电话" placeholder="请填写对方电话" />
          <van-field v-model="contractForm.mySignedUser" label="我方签约人" :rules="[{ required: true}]" required placeholder="请填写我方签约人" />
          <van-field name="uploader" label="合同相片">
            <template #input>
              <van-uploader v-model="pictureList" :after-read="uploadContractPictureFiles" :before-read="beforeRead" :deletable="true" :before-delete="handleContractRemove" :max-count="9" :multiple="true" :max-size="52428800" upload-text="合同相片" />
            </template>
          </van-field>
          <van-field name="uploader" label="电子合同">
            <template #input>
              <van-uploader v-model="fileList" :after-read="uploadContractFiles" :max-count="1" :max-size="52428800" upload-text="电子合同" required>
              </van-uploader>
            </template>
          </van-field>
          <van-field name="uploader" label="附件1">
            <template #input>
              <van-uploader v-model="fileList1" :after-read="uploadContractFiles1" :max-count="1" :max-size="52428800" upload-text="附件1">
              </van-uploader>
            </template>
          </van-field>
          <van-field name="uploader" label="附件2">
            <template #input>
              <van-uploader v-model="fileList2" :after-read="uploadContractFiles2" :max-count="1" :max-size="52428800" upload-text="附件2">
              </van-uploader>
            </template>
          </van-field>

          <van-field v-model="contractForm.remark" label="备注" />
          <van-field v-model="contractForm.content" rows="2" type="textarea" label="合同内容" />
        </van-cell-group>
      </van-form>
    </van-dialog>

    <!-- 日期选择器 -->
    <van-calendar v-model="showStartCalendar" :min-date="minDate" type="single" @confirm="onStartCalendarConfirm" />
    <van-calendar v-model="showEndCalendar" :min-date="minDateStart" type="single" @confirm="onEndCalendarConfirm" />
    <van-calendar v-model="showSignCalendar" :min-date="minDate" type="single" @confirm="onSignCalendarConfirm" />

      <!--生日选择-->
      <van-calendar v-model="showBirthdayCalendar" @confirm="onConfirmBirthday" :min-date="minDate" />
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
      </van-popup>

    </div>
  </div>
</template>

<script>
import { listCust, getCust, delCust, updateCust } from "@/api/scrm/custorder";
import { getSale, delSale, addSale, updateSale, exportSale } from "@/api/scrm/custsale";
import { getProvinceCityList } from "@/api/system/area";
import { getTwoLevelIndustryList } from "@/api/system/qqAdIndustry";
import { selectAllCustLevel } from "@/api/scrm/custlevel"
import { getPutOrder, addContract } from "@/api/cont/putcontract";
import { areaList } from '@vant/area-data';
import { ucloudUpFileToContract, deleteFile } from "@/api/system/common";
import { queryListContact, listContact, getContact, addContact, updateContact, delContact } from "@/api/scrm/custcontact";
import { queryListVisit, addVisit } from "@/api/scrm/custvisit";
import CardInfo from '../../scrm/component/CardInfo.vue'
import ContTab from '../../scrm/component/ContTab.vue'
import { selectAllBusinessType } from "@/api/scrm/custbusinesstype";
import { localeData } from 'moment';
export default {
  components: {
    CardInfo,
    ContTab
  },
  data() {
    return {
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      minDate: new Date(2010, 0, 1),
      minDateStart: new Date(2010, 0, 1),
      isPut: false,
      customer: {},
      listVisit: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 客户回访类型
      custVisitTypeOptions: this.$store.state.dictOptions.custVisitType||[],
      //客户联系人列表
      custContactOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      // 客户意向等级
      custLevelOptions: [],
      // 客户类型
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      //产品类型列表
      businessTypeOptions: this.$store.state.dictOptions.businessTypeTree|| [],
      // 性别状态字典
      sexOptions: this.$store.state.dictOptions.sex || [],
      // 合同状态
      contractStatusOptions: this.$store.state.dictOptions.contractStatus || [],
      // 合同类型
      contractTypeOptions: this.$store.state.dictOptions.contractType || [],
      // 支付方式
      payModeOptions: this.$store.state.dictOptions.payMode || [],
      fileList: [],
      fileList1: [],
      fileList2: [],
      deleteFileList: [],
      captureList: [],
      pictureList: [],
      showStartCalendar: false,
      showEndCalendar: false,
      showSignCalendar: false,
      //证件类型
      ideTypeOptions: [],
      //角色关系
      roleRelationOptions: [],
      //亲密程度
      intimacyOptions: [],
      show: false,
      contract: false,
      //添加回访记录
      visitShow: false,
      //添加联系人
      addContactShow: false,
      //添加修改联系人title
      contactTitle: "",
      //生日
      showBirthdayCalendar: false,
      //证件类型
      showPopupPicker: false,
      active: 0,
      //跟进记录tab
      activeName: 'active_visit',
      // 合同参数
      contractForm: {},
      form: {
        custSaleId: null,
        custId: null,
        custLevelId: null,
        custName: null,
        clueId: null,
        custSource: null,
        custType: null,
        clueStatus: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        custStatus: "8",
        scale: null,
        mainProducts: null,
        custAddress: null,
        custLogo: null,
        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
        turnOpportunityTime: null,
        myUserid: null,
        followUserid: null,
        followUserName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null
      },
      //回访记录
      visitForm: {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null,
      },
      //客户联系人查询条件
      queryContactParams: {
        pageNum: 1,
        pageSize: 100,
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
      },
      // 添加联系记录
      contactForm: {
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
        sex: null,
        mobile: null,
        qq: null,
        email: null,
        weixinSn: null,
        deptName: null,
        jobs: null,
        age: null,
        birthday: null,
        ideType: null,
        ideTypeName: null,
        ideSn: null,
        jobTitle: null,
        nickName: null,
        roleRelation: null,
        roleRelationName: null,
        intimacy: null,
        intimacyName: null,
        hobby: null,
        myUserid: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null
      },
      // 表单校验
      rules: {
        custName: [
          { required: true, message: "客户商名称不能为空", trigger: "blur" }
        ],
        custLevelId: [
          { required: true, message: "客户等级不能为空", trigger: "blur" }
        ],
        custSource: [
          { required: true, message: "客户来源不能为空", trigger: "blur" }
        ],
        custType: [
          { required: true, message: "客户类型不能为空", trigger: "blur" }
        ],
        industryCode: [
          { required: true, message: "行业不能为空", trigger: "blur" }
        ],
        areaId: [{ required: true, message: "地区不能为空", trigger: "blur" }],
        custStatus: [
          { required: true, message: "客户状态不能为空", trigger: "blur" }
        ]
      },
    }
  },
  mounted() {
    //客户状态
    this.getDicts("crm_cust_status").then(response => {
      this.custStatusOptions = response.data;
    });
    //证件类型
    this.getDicts("ide_type").then(response => {
      this.ideTypeOptions = response.data;
    });
    //角色关系
    this.getDicts("role_relation").then(response => {
      this.roleRelationOptions = response.data;
    });
    //亲密程度
    this.getDicts("intimacy").then(response => {
      this.intimacyOptions = response.data;
    });
    // 获取地区（省、市）
    getProvinceCityList().then(response => {
      this.areaOptions = this.handleTree(response.data, "areaId");
    });
    // 获取行业（前2级）
    getTwoLevelIndustryList().then(response => {
      this.industryOptions = this.handleTree(response.data, "systemIndustryId");
    });
    this.getCustLevelList();
    this.init()

  },
  methods: {
    async init() {
      // 列表页传递的 custSaleId ==》仅用于获取详情
      this.isPut = this.$route.params.isPut
      let res = null;
      if(this.isPut){
        //修改主体框架标题
        document.title = "CONT-未上传合同卡片";
        res = await getPutOrder(this.$route.params.id)
      }else {
        //修改主体框架标题
        document.title = "SCRM-订单客户卡片";
        res = await getSale(this.$route.params.id)
      }
      if (res.code === 200) {
        this.customer = res.data
        let custId = res.data.custId;
        this.queryListVisit(custId)
        this.visitForm.custId = custId;
        this.queryContactParams.custId = custId;
        this.getCustContactList(custId);
      }
    },
    contractTypeFormat2(contractType) {
      return this.selectDictLabel(this.contractTypeOptions, contractType);
    },
    contractStatusFormat2(contractStatus) {
      return this.selectDictLabel(this.contractStatusOptions, contractStatus);
    },
    //性别
    contactSexFormat(sex) {
      return this.selectDictLabel(this.sexOptions, sex);
    },
    // 释放方式
    releaseModeFormat(row, column) {
      return this.selectDictLabel(this.releaseModeOptions, row.releaseMode);
    },
    // 释放方式
    releaseModeFormat2(releaseMode) {
      return this.selectDictLabel(this.releaseModeOptions, releaseMode);
    },
    // 客户来源
    custSourceFormat(row, column) {
      return this.selectDictLabel(this.custSourceOptions, row.custSource);
    },
    // 客户来源
    custSourceFormat2(custSource) {
      return this.selectDictLabel(this.custSourceOptions, custSource);
    },
    // 获取客户意向等级名称———详情显示时
    custLevelFormat2(custLevelId) {
      if (this.custLevelOptions != null) {
        let obj = this.custLevelOptions.find(
          item => item.custLevelId === custLevelId
        );
        if (obj != null) {
          return obj.levelName;
        }
      }
    },
    //获取用户等级
    getCustLevelList() {
      selectAllCustLevel(null).then(response => {
        this.custLevelOptions = response.data;
      });
    },
    //获取访问类型
    visitTypeFormat(visitType) {
      if (this.custVisitTypeOptions != null) {
        var visitName = this.selectDictLabel(this.custVisitTypeOptions, visitType);
        if (visitName != null && visitName != '') {
          return "【" + visitName + "】";
        }
      }
    },
    //支付方式字典翻译
    payModeFormat2(payMode) {
      return this.selectDictLabel(this.payModeOptions, payMode);
    },
    payModeFormat(row, column) {
      return this.selectDictLabel(this.payModeOptions, row.payMode);
    },
    onStartCalendarConfirm(data) {
      this.contractForm.startTime = this.formatDate(data);
      this.showStartCalendar = false;
      this.minDateStart = data
    },
    onEndCalendarConfirm(data) {
      this.contractForm.endTime = this.formatDate(data);
      this.showEndCalendar = false;
    },
    onSignCalendarConfirm(data) {
      this.contractForm.signTime = this.formatDate(data);
      this.showSignCalendar = false;
    },
    // 返回布尔值
    beforeRead(file) {
      if (
        file.type !== "image/jpeg" &&
        file.type !== "image/png" &&
        file.type !== "image/jpg"
      ) {
        Toast("请上传 jpg 、jpeg、png 格式图片");
        return false;
      }
      return true;
    },
    uploadContractFiles(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.contractForm.contractFile = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles1(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.contractForm.annexOne = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractFiles2(file) {
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.contractForm.annexTwo = res.url;
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    uploadContractPictureFiles(file) {
      console.log(file);
      const _file = file.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);

      ucloudUpFileToContract(formData)
        .then((res) => {
          console.log("_RequestUploads_", res);
          if (res.code === 200) {
            this.contractForm.contractImg = res.url;
            let picture = this.contractForm.contractImg;
            if (picture != null && picture.length > 0) {
              picture += "," + res.url;
            } else {
              picture = res.url;
            }
            this.contractForm.contractImg = picture;
            let payCaptures = this.contractForm.contractImg.split(",");
            this.pictureList = [];
            payCaptures.forEach((element) => {
              this.pictureList.push({
                url: element,
              });
            });
            Toast.success(res.msg);
          } else {
            Toast.fail("res.msg");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //添加合同
    async addContractBeforeClose(type, done) {
      if (type === "confirm") {
        try {
          await this.$refs["contractForm"].validate();
          addContract(this.contractForm).then((response) => {
            Toast.success("提合同成功");
            this.contract = false;
            if (this.deleteFileList.length > 0) {
            //  deleteFile(this.deleteFileList);
            }
            this.init();
          });
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      } else {
        return done();
      }
    },
    handleContractPut(custSaleId) {
      this.fileList = []
      this.fileList1 = []
      this.fileList2 = []
      this.pictureList = []
      this.deleteFileList = []
      this.contractReset();
      getPutOrder(custSaleId).then((response) => {
        this.contractForm = response.data;
      });
      this.contract = true;
    },
    handleContractRemove(file) {
      let picture = this.contractForm.contractImg;
      if (picture.indexOf(file.url) == 0) {
        if (picture.indexOf(",") == -1) {
          picture = null;
        } else {
          picture = picture.replace(file.url + ",", "");
        }
      } else {
        picture = picture.replace("," + file.url, "");
      }
      this.contractForm.contractImg = picture;
      this.pictureList = [];
      if (this.contractForm.contractImg != null && this.contractForm.contractImg.length > 0) {
        let payCaptures = this.contractForm.payCapture.split(",");
        payCaptures.forEach((element) => {
          this.pictureList.push({
            url: element,
          });
        });
      }
      this.deleteFileList.push(file.url);
      console.log(this.deleteFileList);
    },
    //获取客户联系人记录列表
    getCustContactList(custId) {
      //选择客户时获取该客户的联系人对象
      this.queryContactParams.custId = custId;
      queryListContact(this.queryContactParams).then(response => {
        this.custContactOptions = response.data;
      });
    },
    async queryListVisit(custId) {
      const res = await queryListVisit({ custId })
      console.log(res)
      if (res.code === 200) {
        this.listVisit = res.data
      }
    },
    // /** 申领客户按钮操作 */
    // handleApply(custId) {

    //   Dialog.confirm({
    //       title: '警告',
    //       message: '是否确认申领【我的客户】编号为"' + custId + '"的数据项?'
    //     }).then(
    //       function() {
    //       return applyCust(custId);        

    //     }).then(() => {
    //       Toast.success('申领成功');
    //       this.$router.push({path: '/scrm/custorder'});
    //     }).catch(() => {
    //       Toast.fail('申领失败');
    //     });
    // },
    /** 删除按钮操作 */
    handleDelete(custId) {

      Dialog.confirm({
        title: '警告',
        message: '是否确认删除【我的客户】编号为"' + custId + '"的数据项?'
      }).then(
        function () {
          return delCust(custId);
        }).then(() => {
          Toast.success('删除成功');
          this.$router.push({ path: '/scrm/custorder' });
        }).catch(() => {
        });
    },
    submitUpdate() {
      updateCust(this.form).then(response => {
        Toast.success('修改成功');
        this.show = false;
        this.init();
      });
    },
    // 商机客户验证
    async beforeUpdateClose(type, done) {
      if (type === "confirm") {
        try {
          await this.$refs["form"].validate();
          updateSale(this.form).then(response => {
            Toast.success('修改成功');
            this.show = false;
            this.init();
          });
          done();
        } catch (err) {
          return done(false);
        }
        return done(false);
      } else {
        return done();
      }
    },
    //添加回访记录
    addVisit() {
      this.visitFormReset();
      this.visitForm.custId = this.customer.custId;
      this.visitForm.custName = this.customer.custName;
      this.visitShow = true;
    },
    showPicker(type) {
      this.picker.formKey = type
      if (type === 'custLevelId') {
        this.picker.columns = this.custLevelOptions.map(ele => ele.levelName)
      }
      if (type === 'custSource') {
        this.picker.columns = this.custSourceOptions.map(ele => ele.dictLabel)
      }
      if (type === 'custType') {
        this.picker.columns = this.custTypeOptions.map(ele => ele.dictLabel)
      }
      if (type === 'businessTypeId') {
        this.picker.columns = this.businessTypeOptions.map(ele => this.businessNormalizer(ele))
      }
      if (type === 'industryCode') {
        this.picker.columns = this.industryOptions.map(ele => this.industryNormalizer(ele))
      }
      if (type === 'areaId') {
        this.picker.columns = this.areaOptions.map(ele => this.areaNormalizer(ele))
      }
      //回访联系类型    
      if (type === 'visitType') {
        this.picker.columns = this.custVisitTypeOptions.map(ele => ele.dictLabel);
      }
      //回访联系人
      if (type === 'contactId') {
        this.picker.columns = this.custContactOptions.map(ele => ele.contactName);
      }
      if (type === 'ideType') {
        this.picker.columns = this.ideTypeOptions.map(ele => ele.dictLabel);
      }
      if (type === 'roleRelation') {
        this.picker.columns = this.roleRelationOptions.map(ele => ele.dictLabel)
      }
      if (type === 'intimacy') {
        this.picker.columns = this.intimacyOptions.map(ele => ele.dictLabel)
      }
      if (type === "contractType") {
        this.picker.columns = this.contractTypeOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "contractStatus") {
        this.picker.columns = this.contractStatusOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "payMode") {
        this.picker.columns = this.payModeOptions.map((ele) => ele.dictLabel);
      }
      this.picker.visible = true
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === 'custLevelId') {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId
        this.form.custLevelName = this.custLevelOptions[index].levelName
      }
      if (this.picker.formKey === 'custSource') {
        this.form.custSource = this.custSourceOptions[index].dictValue
        this.form.custSourceName = this.custSourceOptions[index].dictLabel
      }
      if (this.picker.formKey === "contractType") {
        this.contractForm.contractType =
          this.contractTypeOptions[index].dictValue;
        this.contractForm.contractTypeName =
          this.contractTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "contractStatus") {
        this.contractForm.contractStatus =
          this.contractStatusOptions[index].dictValue;
        this.contractForm.contractStatusName =
          this.contractStatusOptions[index].dictLabel;
      }
      if (this.picker.formKey === "payMode") {
        this.contractForm.payMode = this.payModeOptions[index].dictValue;
        this.contractForm.payModeName = this.payModeOptions[index].dictLabel;
      }
      // 产品类型
      if (this.picker.formKey === 'businessTypeId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.businessTypeName = value[0] + '/' + value[1]
            let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
            if (obj != null) {
              this.form.businessTypeId = obj.children.find(item => item.businessTypeName === value[1]).businessTypeId
            }
          }

        } else {
          this.form.businessTypeName = value[0]
          let obj = this.businessTypeOptions.find(item => item.businessTypeName === value[0])
          if (obj != null) {
            this.form.businessTypeId = obj.businessTypeId
          }
        }

      }
      if (this.picker.formKey === 'custType') {
        this.form.custType = this.custTypeOptions[index].dictValue
        this.form.custTypeName = this.custTypeOptions[index].dictLabel
      }
      if (this.picker.formKey === 'industryCode') {

        if (value.length == 2) {
          if (value[1].length > 0) {
            this.form.industryName = value[0] + '/' + value[1]
            let obj = this.industryOptions.find(item => item.industryName === value[0])
            if (obj != null) {
              this.form.industryCode = obj.children.find(item => item.industryName === value[1]).systemIndustryId
            }
          }

        } else {
          this.form.industryName = value[0]
          let obj = this.industryOptions.find(item => item.industryName === value[0])
          if (obj != null) {
            this.form.industryCode = obj.systemIndustryId
          }
        }

      }
      if (this.picker.formKey === 'areaId') {
        if (value.length == 2) {
          if (value[1].length > 0) {
            let obj = this.areaOptions.find(item => item.areaName === value[0])
            if (obj != null) {
              this.form.areaId = obj.children.find(item => item.areaName === value[1]).areaId
            }
            this.form.areaName = value[0] + '/' + value[1]
          }

        } else {
          this.form.areaName = value[0]
          let obj = this.areaOptions.find(item => item.areaName === value[0])
          if (obj != null) {
            this.form.areaId = obj.areaId
          }
        }

      }
      //回访联系类型  
      if (this.picker.formKey === 'visitType') {
        this.visitForm.visitType = this.custVisitTypeOptions[index].dictValue
        this.visitForm.visitTypeName = this.custVisitTypeOptions[index].dictLabel
      }
      //回访联系人
      if (this.picker.formKey === 'contactId') {
        this.visitForm.contactId = this.custContactOptions[index].contactId
        this.visitForm.contactName = this.custContactOptions[index].contactName
      }
      if (this.picker.formKey === 'ideType') {
        this.contactForm.ideType = this.ideTypeOptions[index].dictValue
        this.contactForm.ideTypeName = this.ideTypeOptions[index].dictLabel
      }
      if (this.picker.formKey === 'roleRelation') {
        this.contactForm.roleRelation = this.roleRelationOptions[index].dictValue
        this.contactForm.roleRelationName = this.roleRelationOptions[index].dictLabel
      }
      if (this.picker.formKey === 'intimacy') {
        this.contactForm.intimacy = this.intimacyOptions[index].dictValue
        this.contactForm.intimacyName = this.intimacyOptions[index].dictLabel
      }
      this.picker.visible = false
    },
    areaConfirm(values) {
      this.form.areaId = values[values.length - 1].code
      this.form.areaName = values[values.length - 1].name
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false;
    },
    pickerChange() { },
    handleUpdate(custId) {
      getSale(custId).then(response => {
        this.form = response.data
        let custlevel = this.custLevelOptions.find((item, index) => {
          return item.custLevelId == this.form.custLevelId;
        })
        let custType = this.custTypeOptions.find((item, index) => {
          return item.dictValue == this.form.custType;
        })
        let custSource = this.custSourceOptions.find((item, index) => {
          return item.dictValue == this.form.custSource;
        })
        if (custlevel != null) {
          this.form.custLevelName = custlevel.levelName
        }
        if (custType != null) {
          this.form.custTypeName = custType.dictLabel
        }
        if (custSource != null) {
          this.form.custSourceName = custSource.dictLabel
        }
        this.show = true
      })
    },
    /** 转换地区数据结构 */
    areaNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].areaId,
            text: node.children[i].areaName
          }
          arr.push(item)
        }
      }
      return {
        id: node.areaId,
        text: node.areaName,
        children: arr
      };
    },
    /** 转换行业数据结构 */
    industryNormalizer(node) {
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].systemIndustryId,
            text: node.children[i].industryName
          }
          arr.push(item)
        }
      }
      return {
        id: node.systemIndustryId,
        text: node.industryName,
        children: arr
      };
    },
    /** 转换产品类型数据结构 */
    businessNormalizer(node) {
      console.log(node);
      let arr = []
      if (node.children && node.children.length) {
        for (let i in node.children) {
          let item = {
            id: node.children[i].businessTypeId,
            text: node.children[i].businessTypeName
          }
          arr.push(item)
        }
      }
      return {
        id: node.businessTypeId,
        text: node.businessTypeName,
        children: arr
      };
    },
    addContract() {
      this.contactTitle = "添加【我的联系人】";
      this.contactFormReset()
      //点击添加时初使化
      this.contactForm.custId = this.customer.custId;
      this.contactForm.custName = this.customer.custName;
      this.addContactShow = true;
    },
    //修改联系人
    handleUpdateContact(contactId) {
      getContact(contactId).then(response => {
        this.contactForm = response.data;
        this.addContactShow = true;
        this.contactTitle = "修改【我的联系人】";
      });
    },
    //删除联系人
    handleDelContact(contactId) {
      Dialog.confirm({
        title: '警告',
        message: '是否确认删除【联系人】编号为"' + contactId + '"的数据项吗?'
      }).then(
        function () {
          return delContact(contactId);
        }).then(() => {
          Toast.success('删除成功');
          this.getCustContactList(this.customer.custId);
        }).catch(() => {
          //取消了
        });
    },
    //新增联系人
    async beforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs["addForm"].validate()
          if (this.contactForm.contactId != null) {
            const responses = updateContact(this.contactForm).then(response => {
              this.getCustContactList(this.contactForm.custId);
              Toast.success('修改联系人成功!');
            });
          } else {
            const response = await addContact(this.contactForm).then(response => {
              this.getCustContactList(this.contactForm.custId);
              Toast.success('新增联系人成功!');
            });
          }
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    //添加回访记录
    async visitBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs["addVisitForm"].validate()
          addVisit(this.visitForm).then(response => {
            //选择客户时获取该客户的回访记录
            this.visitShow = false;
            this.visitForm.content = null;
            this.visitForm.visitType = null;
            this.visitForm.visitTypeName = null;
            this.queryListVisit();
            Toast.success('回访记录新增成功!');
          });
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    formatDate(date) { // 时间格式化 2019-09-08
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return year + '-' + month + '-' + day
    },
    onConfirmBirthday(data) {
      this.contactForm.birthday = this.formatDate(data);
      this.showBirthdayCalendar = false;
    },
    reset() {
      this.form = {
        custId: null,
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        releaseMode: null,
        custStatus: "0",
        scale: null,
        mainProducts: null,
        custAddress: null,
        custLogo: null,
        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
        turnOpportunityTime: null,
        myUserid: null,
        followUserid: null,
        followUserName: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null
      };
    },
    contractReset() {
      this.contractForm = {
        contractId: null,
        custOrderId: null,
        contractNum: null,
        contractName: null,
        custId: null,
        custName: null,
        contractSource: null,
        contractType: null,
        contractStatus: null,
        payMode: null,
        contractTypeName: null,
        contractStatusName: null,
        payModeName: null,
        hkStatus: null,
        verifyStatus: "0",
        contractMoney: null,
        startTime: null,
        endTime: null,
        signedUserMobile: null,        
        custSignedUser: null,
        mySignedUser: null,
        signTime: null,
        contractImg: null,
        contractFile: null,
        annexOne: null,
        annexTwo: null,
        content: null,
        readerCount: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        remark: null,
      };
    },
    contactFormReset() {
      this.contactForm = {
        contactId: null,
        contactName: null,
        custId: null,
        custName: null,
        sex: null,
        mobile: null,
        qq: null,
        email: null,
        weixinSn: null,
        deptName: null,
        jobs: null,
        age: null,
        birthday: null,
        ideType: null,
        ideTypeName: null,
        ideSn: null,
        jobTitle: null,
        nickName: null,
        roleRelation: null,
        roleRelationName: null,
        intimacy: null,
        intimacyName: null,
        hobby: null,
        myUserid: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        status: "0",
        delFlag: null,
        orderNum: null,
        remark: null
      }
    },

    visitFormReset() {
      this.visitForm = {
        content: null,
        visitType: null,
        custId: null,
        custName: null,
        contactId: null,
        contactName: null,
        custSaleId: null,
      }
    }

  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");
.custclue-container {
  height: 100vh;
  background-color: #eee;
  font-size: 20px;
  .custclue-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    padding: 20px 10px 10px 30px;
  }
  .tag-wrapper {
    display: flex;
    justify-content: center;
  }
  .b-g-w {
    background-color: #fff;
  }
  .m-b-20 {
    margin-bottom: 20px;
  }

  .key {
    color: #ccc;
  }
  .value {
    color: #ccc;
  }
  .concat-container {
    background-color: #fff;

    margin-bottom: 90px;
    .concat-header {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .concat-list {
      .concat-item {
        border-bottom: 1px solid #eee;
        font-size: 26px;
        margin-left: 15px;
        margin-right: 15px;
        padding: 20px;
        .content-footer {
          color: #ccc;
        }
        span {
          font-size: 26px;
        }
      }
      .content-main {
        span {
          font-size: 26px;
          color: #ccc;
        }
      }
    }
  }
}
</style>
